// src/modules/app-views/companies/pages/Init/components/tableColumns/cityColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { EnvironmentOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function cityColumn(buildColumnProps, options = {}) {
  const {
    key = 'city',
    title = 'city',
    dataIndex = ['address', 'city'],
    width, // = 150,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps('address.city', columnProps),
    render: (_, r) => {
      const location =
        r?.address?.__city ||
        (r?.address?.city && r?.address?.region
          ? `${r.address.city}/${r.address.region}`
          : r?.address?.city);
      return location ? (
        <span>
          <EnvironmentOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
          {location}
        </span>
      ) : (
        '—'
      );
    },
  };
}

export default cityColumn;
